import { tw } from "@careinfo/tailwind";
import { yupResolver } from "@hookform/resolvers/yup";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { validatePaymentReceipt } from "../../../../validation/BankPaymentReceipt";
import Button from "../../../Reusable/Button";
import Card from "../../../Reusable/Card";
import PopupModal from "../../../Reusable/Modal";
import BankForm from "../BankForm";
import { useNavigate } from "react-router-dom";
import CreatePartyPopup from "../../CreatePartyPopup";
import CreateAccountPopup from "../CreateAccountPopup";

const CreateBankReceipt = (props: any) => {
  const [openpartypopup, setpartypopup] = useState(false);
  const navigate = useNavigate();
  const [openAccountPopup, setOpenAccountPopup] = useState(false);
  const {
    handleCreate,
    isLoading,
    handleCreateBankAccount,
    isPostLoading,
    openPrintPopup,
    setOpenPrintPopup,
    isPrintLoading,
    billRefetch,
    numberSeriesRefetch,
    handlePrint,
  } = props;
  const {
    control,
    register,
    formState: { errors },
    setValue,
    getValues,
    handleSubmit,
    clearErrors,
    setError,
    watch,
  } = useForm<any>({
    resolver: yupResolver(validatePaymentReceipt),
    defaultValues: async () => {
      const countData = await billRefetch();
      const numberSeries = await numberSeriesRefetch();
      const today = new Date().toISOString().split("T")[0];

      return {
        number_series: numberSeries?.data?.[0]?.next_series,
        entry_number: `${countData?.data?.count + 1}`,
        voucher_date: today,
        account: {
          id: "bb78b73b-5aed-4f0e-a913-5cdf33753e58",
          name: "Bank A/c",
        },
      };
    },
  });

  const handleClosePrint = () => {
    setOpenPrintPopup(false);
    navigate("/accounting/bank-receipt");
  };
  return (
    <>
      <Card>
        <form
          onSubmit={handleSubmit((data) => handleCreate(data, false, setError))}
        >
          <BankForm
            control={control}
            register={register}
            errors={errors}
            setValue={setValue}
            getValues={getValues}
            clearErrors={clearErrors}
            setError={setError}
            watch={watch}
            setOpenAccountPopup={setOpenAccountPopup}
            setPartypopup={setpartypopup}
          />
          <div className={tw`w-full flex gap-x-4 justify-end px-4`}>
            <div className={tw`w-24 `}>
              <Button
                type="button"
                label="Save to Draft"
                isLoading={isLoading}
                onClick={handleSubmit((data) =>
                  handleCreate(data, true, setError)
                )}
              />
            </div>
            <div className={tw`w-24 `}>
              <Button label="Submit" isLoading={isLoading} />
            </div>
          </div>
        </form>
      </Card>
      <PopupModal
        isOpen={openAccountPopup}
        setIsOpen={setOpenAccountPopup}
        title="Bank Account"
      >
        <CreateAccountPopup
          handleCreateAccount={handleCreateBankAccount}
          isLoading={isPostLoading}
          setOpenAccountPopup={setOpenAccountPopup}
        />
      </PopupModal>
      <PopupModal
        isOpen={openpartypopup}
        setIsOpen={setpartypopup}
        title="Party Account"
      >
        <CreatePartyPopup setpartypopup={setpartypopup} setParty={setValue} />
      </PopupModal>
      <PopupModal
        isOpen={openPrintPopup}
        setIsOpen={handleClosePrint}
        title={"Print"}
      >
        <form action="#" className={tw`w-[600px]`}>
          <Button
            label={"Print "}
            type="button"
            isLoading={isPrintLoading}
            disabled={isPrintLoading}
            onClick={handlePrint}
            autoFocus
          />
          <Button
            type="button"
            label={"Close"}
            onClick={() => handleClosePrint()}
          />
        </form>
      </PopupModal>
    </>
  );
};
export default CreateBankReceipt;
